import { toast } from "react-toastify";
import {
    likeFeedOrComment,
    postDeleteFeed,
    postHideFeedItem,
    unlikeFeedOrComment,
    postEditPost
} from "../../../utils/api/functions/advancedActivityFeeds";
import { postReportContent } from "../../../utils/api/functions/misc";
import { postBlockMember } from "../../../utils/api/functions/members";

export const useFeedActions = ({ data, mutate }) => {
  const handleLike = async (action_id, reaction=null) => {
    const updated = new Array(...data);
    for (const page of updated) {
      for (const item of page.body.data) {
        if (item.feed.action_id === action_id) {
          item.is_like = 1;
          
          // Optimistically populate reaction (only populate necessary fields)
          if(reaction) {
            if(!item.feed_reactions) item.feed_reactions = {};
            if(!item.feed_reactions[reaction.id]) {
              item.feed_reactions[reaction.id] = {
                caption: reaction.caption, 
                reaction_count: 1
              };
            } else {
              item.feed_reactions[reaction.id].reaction_count++;
            }
          }
          break;
        }
      }
    }

    await mutate(
      async () => {
        const formData = new FormData();
        formData.append("action_id", action_id);
        if(reaction) formData.append("reaction", reaction.type);
        await likeFeedOrComment(formData);
        return updated;
      },
      {
        optimisticData: updated,
        rollbackOnError: true,
        populateCache: true,
        revalidate: false,
      }
    );
  };

  const handleUnlike = async (action_id) => {
    const updated = new Array(...data);

    for (const page of updated) {
      for (const item of page.body.data) {
        if (item.feed.action_id === action_id) {
          item.is_like = 0;
          break;
        }
      }
    }

    await mutate(
      async () => {
        const formData = new FormData();
        formData.append("action_id", action_id);
        await unlikeFeedOrComment(formData);
        return updated;
      },
      {
        optimisticData: updated,
        rollbackOnError: true,
        populateCache: true,
        revalidate: false,
      }
    );
  };

  const handleDelete = async (action_id) => {
    const res = await postDeleteFeed({ action_id });

    if (res.status_code === 204) {
      toast.success("Post deleted successfully");
      mutate();
    }
  };

  const handleHidePost = async (action_id) => {
    const res = await postHideFeedItem({
      id: action_id,
      type: "activity_action",
    });

    if (res.status_code === 204) {
      toast.success("Post hidden successfully");
      mutate();
    }
  };

  const handleUpdate = () => {
    mutate();
  };

  const handleEditPost = async (postId, content) => {
    const res = await postEditPost({
      action_id: postId, 
      body: content
    });
    const updated = new Array(...data); 
    for (const page of updated) {
      for (const item of page.body.data) {
        if (item.feed.action_id === postId) {
          item.feed.body = content; 
          break;
        }
      }
    }

    if (res.status_code === 200 || res.status_code === 204) {
      toast.success("Post updated successfully");
      mutate(
        updated,
        {
          optimisticData: updated,
          rollbackOnError: true,
          populateCache: true,
          revalidate: false,
        }
      );
    } else {
      toast.error("Error updating post");
    }
  };
  
  const handleReportPost = async(action_id, reason, details) => {
    const formData = new FormData();
    formData.append("id", action_id);
    formData.append("type", "activity_action");
    formData.append("category", reason);
    formData.append("description", details);
    const res = await postReportContent(formData);

    if (res.status_code === 200 || res.status_code === 204) {
      toast.success("Post reported successfully");
      mutate();
    } else {
      toast.error("Error reporting post");
    }
  }

  // Can only block users currently
  // @TODO: implement blocking functionality for pages, groups, events? 
  const handleBlockByPostId = async(action_id) => {

    // Get the user id from the post id in paginated data (data contains arrays of the typical data)
    let post; 

    for (const page of data) {
      post = page.body.data.find(item => item.feed.action_id === action_id);
      if (post) break;
    }

    console.log("blocking user by post: ", post); 
    const user_id = post ? post.feed.subject_id : null;
    const res = await postBlockMember(user_id);

    if (res.status_code === 200 || res.status_code === 204) {
      toast.success("User blocked successfully");

      // Optimistically remove all posts by the user from data ( needs improvement )
      // const updated = new Array(...data);
      // for (const page of updated) {
      //   page.body.data = page.body.data.filter(item => item.feed.subject !== user_id);
      // }
      // mutate(updated, {
      //   optimisticData: updated,
      //   rollbackOnError: true,
      //   populateCache: true,
      //   revalidate: false,
      // });
      mutate(); 
    } else {
      toast.error("Error blocking user");
    }
  }

  return {
    handleLike,
    handleUnlike,
    handleDelete,
    handleHidePost,
    handleUpdate,
    handleEditPost,
    handleReportPost,
    handleBlockByPostId
  };
};
